import { SelectOptionType } from "@/components";

export enum ActionFieldDisplayTypes {
  Input = "input",
  Dropdown = "dropdown",
  Disabled = "disabled",
}
export type FieldTypes = "input" | "dropdown" | "disabled";

export type AcceptableValidationTypes =
  | "numeric"
  | "boolean"
  | "string"
  | "date";
export type AcceptableFieldTypes = AcceptableValidationTypes;

export interface ActionFieldConfig {
  displayType: ActionFieldDisplayTypes;
  validationType: AcceptableFieldTypes;
  options?: SelectOptionType[];
  placeholder?: string;
  isDisabled?: boolean;
}

export interface FormFieldTypes {
  displayType: FieldTypes;
  validationType: AcceptableFieldTypes;
}
